import React from 'react'
import Page from '../components/Page'

import { getWpData } from '../data/general'

export default function Financials (props) {
  const { title: heading, content: content, slug: slug } = props.wp

  return (
    <React.Fragment>
      <Page title={heading.rendered} slug={'/' + slug} body={content.rendered}>
        <main id='content'>
          <div className='container single-page'>
            <div className='row'>
              <div className='col-md-8 offset-md-2'>
                <h1
                  className='heading1'
                  dangerouslySetInnerHTML={{ __html: heading.rendered }}
                />
                <div
                  dangerouslySetInnerHTML={{
                    __html: content.rendered //props.page.fullArticle.content.rendered
                  }}
                />
              </div>
            </div>
          </div>
        </main>
      </Page>
    </React.Fragment>
  )
}
